import { FC } from 'react';

import { TextWithTooltip } from 'shared/components/TextWithTooltip';
import { Text } from 'shared/components/Text';
import { PersonIcon } from 'shared/components/Icons';
import { convertMillisecondsToTime } from 'shared/utils/date';
import { TConsultationQueueRecord } from 'shared/types';
import classes from './styles.module.scss';

export const Card: FC<TConsultationQueueRecord> = ({
  patient,
  products,
  provider,
  difference
}) => (
  <div className={classes.wrapper}>
    <PersonIcon />
    <div className={classes.content}>
      <TextWithTooltip type="m-body-emphasized">{patient}</TextWithTooltip>
      <TextWithTooltip type="m-caption-emphasized" color="grey-second">
        {products}
      </TextWithTooltip>
      <TextWithTooltip type="m-caption" color="grey-second">
        {provider}
      </TextWithTooltip>
    </div>
    <div className={classes.time}>
      <Text type="sf-caption">{convertMillisecondsToTime(difference)}</Text>
    </div>
  </div>
);
